module.exports = __webpack_public_path__ + "media/dashboard/assets/images/channels/twilio-71bb773085a13b6d086b79a50e6fde84.png";